"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8182],{

/***/ 62673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ZerodhaAccountButton; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function ZerodhaAccountButton(_ref) {
  var children = _ref.children,
      props = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    href: "https://bit.ly/3phrkey1",
    target: "_blank",
    source: "zerodha-account-button"
  }, props), {}, {
    children: children
  }));
}

/***/ }),

/***/ 61373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71577);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var WrappedButton = function WrappedButton(_ref) {
  var children = _ref.children,
      props = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var onClick = props.onClick,
      updatedProps = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded2);

  var onClickHandler = function onClickHandler(event) {
    if (props.source) {
      (0,shared_util__WEBPACK_IMPORTED_MODULE_2__/* .mixpanel_event */ .Zd)('button.click', {
        source: props.source
      });
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, _objectSpread(_objectSpread({
    onClick: onClickHandler
  }, updatedProps), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);

/***/ }),

/***/ 25595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var authStatus = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  logged: false
}); // Create a context object

/* harmony default export */ __webpack_exports__["Z"] = (authStatus); // Export it so it can be used by other Components

/***/ }),

/***/ 43911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var authToken = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  jwt: null
}); // Create a context object

/* harmony default export */ __webpack_exports__["Z"] = (authToken); // Export it so it can be used by other Components

/***/ }),

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ApplicationLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-ga4/dist/index.js
var dist = __webpack_require__(49089);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 5 modules
var notification = __webpack_require__(54689);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var es_message = __webpack_require__(2453);
// EXTERNAL MODULE: ./components/shared/ZerodhaAccount.tsx
var ZerodhaAccount = __webpack_require__(62673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shared/banners/zerodha.js


function RightSideBanner() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: "https://bit.ly/3phrkey1",
    target: "_blank",
    rel: "noreferrer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
      alt: "Zerodha Account"
    })
  });
}
function TallBanner() {
  return /*#__PURE__*/_jsx("a", {
    href: "https://bit.ly/3phrkey1",
    children: /*#__PURE__*/_jsx("img", {
      src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
      alt: "Zerodha Account"
    })
  });
}
// EXTERNAL MODULE: ./contexts/authStatus.ts
var authStatus = __webpack_require__(25595);
// EXTERNAL MODULE: ./contexts/authToken.ts
var authToken = __webpack_require__(43911);
// EXTERNAL MODULE: ./node_modules/enquire-js/main.js
var main = __webpack_require__(80840);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(89971);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/redux-flash-messages/lib/index.js
var redux_flash_messages_lib = __webpack_require__(64515);
;// CONCATENATED MODULE: ./helpers/flash-messages.jsx








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var FlashMessage = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(FlashMessage, _Component);

  var _super = _createSuper(FlashMessage);

  function FlashMessage() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FlashMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleClose", function (event, reason) {
      if (reason === 'clickaway') {
        return;
      } // eslint-disable-next-line react/no-unused-state


      _this.setState({
        open: false
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onFlashMessageClick", function (flashMessage) {
      return function () {
        /*
          Make sure the onClick is called when a user clicks
          on the flash message.
           Otherwise callbacks on Flash Messages will not work.
        */
        flashMessage.onClick(flashMessage); // This implementation deletes the flash message when it is clicked.
        // eslint-disable-next-line react/destructuring-assignment,react/prop-types

        _this.props.dispatch((0,redux_flash_messages_lib.removeFlashMessage)(flashMessage.id));
      };
    });

    return _this;
  }

  (0,createClass/* default */.Z)(FlashMessage, [{
    key: "render",
    value: function render() {
      var messages = this.props.messages;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: messages.map(function (message) {
          return es_message/* default.info */.ZP.info({
            content: message.text,
            key: message.id
          });
        })
      });
    }
  }]);

  return FlashMessage;
}(react.Component); // Retrieve data from store as props


function mapStateToProps(state) {
  return {
    messages: state.flashMessage.messages
  };
}

/* harmony default export */ var flash_messages = ((0,redux/* compose */.qC)((0,es/* connect */.$j)(mapStateToProps))(FlashMessage));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/rc-tween-one/es/index.js + 9 modules
var rc_tween_one_es = __webpack_require__(36193);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./layouts/Footer.js


var _excluded = ["title", "childWrapper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var countries = [{
  id: 1,
  name: 'India',
  value: 'in',
  img: '/in.png'
}, {
  id: 2,
  name: 'Canada',
  value: 'ca',
  img: '/ca.png'
}, {
  id: 3,
  name: 'US',
  value: 'us',
  img: '/us.png'
}];

var getLiChildren = function getLiChildren(data) {
  return data.map(function (item, i) {
    var title = item.title,
        childWrapper = item.childWrapper,
        itemProps = (0,objectWithoutProperties/* default */.Z)(item, _excluded);

    if (i !== data.length - 1) return /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, _objectSpread(_objectSpread({}, itemProps), {}, {
      title: null,
      content: null,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", _objectSpread(_objectSpread({}, title), {}, {
        children: typeof title.children === 'string' && title.children.match(util/* isImg */.ev) ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: title.children,
          width: "100%",
          alt: "img"
        }) : title.children
      })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, childWrapper), {}, {
        children: childWrapper.children.map(util/* getChildrenToRender */.TU)
      }))]
    }), i.toString());
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, _objectSpread(_objectSpread({}, itemProps), {}, {
      title: null,
      content: null,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", _objectSpread(_objectSpread({}, title), {}, {
        children: typeof title.children === 'string' && title.children.match(util/* isImg */.ev) ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: title.children,
          width: "100%",
          alt: "img"
        }) : title.children
      })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, childWrapper), {}, {
        children: childWrapper.children
      }))]
    }), i.toString());
  });
};

var Footer = function Footer(props) {
  var allPages = props.allPages;
  var router = (0,next_router.useRouter)();

  if (true) {
    var cookies = (0,nookies_dist.parseCookies)();

    if (!cookies.country && !(router.route.includes('/article') || router.route.includes('/ipos'))) {
      var country = navigator.language;
      (0,nookies_dist.setCookie)(null, 'country', "".concat(country.slice(country.indexOf('-') + 1).toLowerCase()), {
        path: '/' // cookie path

      });
    }
  }

  var allSlugs = allPages.map(function (entry) {
    return {
      slug: entry.attributes.slug,
      title: entry.attributes.title
    };
  });
  var dataSource = {
    wrapper: {
      className: 'home-page-wrapper footer1-wrapper'
    },
    OverPack: {
      className: 'footer1',
      playScale: 0.2
    },
    block: {
      className: 'home-page',
      gutter: 0,
      children: [{
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: "Fintrakk"
          })
        },
        childWrapper: {
          className: 'slogan',
          children: [{
            name: 'content0',
            children: 'Your finances on track'
          }]
        }
      }, {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: 'Sections'
        },
        childWrapper: {
          children: [{
            name: 'link0',
            href: '/brokers',
            children: 'Brokers'
          }, {
            name: 'link1',
            href: '/ipos/all',
            children: 'IPOs'
          }, {
            name: 'link2',
            href: '/financial-terms',
            children: 'Financial Terms'
          }, {
            name: 'link3',
            href: '/trading-softwares',
            children: 'Softwares'
          }, {
            name: 'link4',
            href: '/calculators',
            children: 'Calculators'
          }, {
            name: 'link5',
            href: '/cities',
            children: 'Cities'
          }]
        }
      }]
    },
    copyrightWrapper: {
      className: 'copyright-wrapper'
    },
    copyrightPage: {
      className: 'home-page'
    },
    copyright: {
      className: 'copyright',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: ["\xA92020 by ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://fintrakk.com",
          children: "Fintrakk"
        }), " All Rights Reserved"]
      })
    }
  };
  dataSource.block.children.push({
    name: 'block1',
    xs: 24,
    md: 6,
    className: 'block',
    title: {
      children: 'About Us'
    },
    childWrapper: {
      children: allSlugs.map(function (page, pos) {
        return {
          name: "link".concat(pos),
          href: "/page/".concat(page.slug),
          children: "".concat(page.title)
        };
      })
    }
  });
  dataSource.block.children.push({
    name: 'block1',
    xs: 24,
    md: 6,
    className: 'block',
    title: {
      children: 'Select Country'
    },
    childWrapper: {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        children: countries.map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
            type: "default",
            onClick: function onClick() {
              document.cookie = "country=".concat(item.value);
              router.push("/".concat(item.value));
            },
            block: true,
            style: {
              border: 0,
              borderRadius: 0,
              height: 30,
              color: '#999',
              backgroundColor: '#001529'
            },
            source: "country-select",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
              style: {
                alignItems: 'center'
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
                style: {
                  paddingLeft: '0px',
                  height: '20px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.img,
                  alt: "Picture of the country",
                  width: 20,
                  height: 20
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
                style: {
                  paddingLeft: '15px'
                },
                children: "".concat(item.name)
              })]
            })
          }, i);
        })
      })
    }
  });
  var childrenToRender = getLiChildren(dataSource.block.children);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread(_objectSpread({}, props), dataSource.wrapper), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "footer1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, _objectSpread(_objectSpread({}, dataSource.block), {}, {
        children: childrenToRender
      })), /*#__PURE__*/(0,jsx_runtime.jsxs)(rc_tween_one_es/* default */.ZP, _objectSpread(_objectSpread({
        animation: {
          y: '+=30',
          opacity: 0,
          type: 'from'
        }
      }, dataSource.copyrightWrapper), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, dataSource.copyrightPage), {}, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, dataSource.copyright), {}, {
            children: dataSource.copyright.children
          }))
        })), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "home-page",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Disclaimer:"
          }), " The content on this site is for informational and educational purposes only. This website is an informational platform only and not a substitute for any professional advice. The readers and subscribers should take required professional advice before making any decisions based on the information given here."]
        })]
      }), "copyright")]
    })
  }));
};

Footer.defaultProps = {
  className: 'footer1'
};
/* harmony default export */ var layouts_Footer = (Footer);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MenuOutlined.js + 1 modules
var MenuOutlined = __webpack_require__(60532);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 12 modules
var menu = __webpack_require__(82610);
;// CONCATENATED MODULE: ./layouts/header/nav3.js


var nav3_excluded = ["isMobile", "allBrokers", "navCalculators"];

function nav3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function nav3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? nav3_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : nav3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var Logout = function Logout() {
  localStorage.clear();
  (0,redux_flash_messages_lib.addSuccess)({
    text: 'Successfully Logged Out'
  });
  router_default().push('/auth/signin');
};

var Login = function Login() {
  router_default().push('/auth/signin');
};

var dataSource = function dataSource(_ref) {
  var loggedIn = _ref.loggedIn,
      allBrokers = _ref.allBrokers,
      navCalculators = _ref.navCalculators;
  var router = (0,next_router.useRouter)();
  var country_slug = router.query.country_slug;
  return {
    wrapper: {
      className: 'header3 home-page-wrapper'
    },
    page: {
      className: 'home-page'
    },
    logo: {
      className: 'header3-logo',
      children: '/static/images/logo.svg'
    },
    Menu: {
      className: 'header3-menu',
      style: {
        width: loggedIn ? 560 : 460
      },
      dataArray: [{
        label: country_slug ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/".concat([country_slug], "/create-post"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Ask Query"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/in/create-post",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Ask Query"
          })
        }),
        key: 'item-create-blog',
        className: 'header3-item'
      }, {
        label: 'Brokers',
        key: 'item0',
        className: 'header3-item',
        children: allBrokers.map(function (broker, idx) {
          var _ref2 = broker.attributes || {},
              slug = _ref2.slug;

          return {
            className: 'item-sub',
            label: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/broker/".concat(slug),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  alignItems: 'center'
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: broker.attributes.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  style: {
                    fontSize: '0.8rem'
                  },
                  children: [broker.attributes.name, " reviews"]
                })]
              })
            }),
            key: "item-".concat(idx),
            style: {
              height: 50,
              lineHeight: 0.7,
              display: 'flex',
              alignItems: 'center',
              margin: '10px 30px'
            },
            icon: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "https://gw.alipayobjects.com/zos/rmsportal/ruHbkzzMKShUpDYMEmHM.svg",
              width: 30,
              height: 30
            })
          };
        })
      }, {
        label: 'Calculators',
        key: 'item1',
        className: 'header3-item',
        children: navCalculators.map(function (calcualtor, idx) {
          var _ref3 = calcualtor.attributes || {},
              slug = _ref3.slug;

          return {
            className: 'item-sub',
            label: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/calculator/".concat(slug),
              children: calcualtor.attributes.name
            }),
            key: "item-".concat(idx)
          };
        })
      }, {
        label: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "https://fintrakk.com",
          children: "Blog"
        }),
        key: 'item-Blog',
        className: 'header3-item'
      }, loggedIn && {
        label: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/auth/edit",
          children: "Edit Profile"
        }),
        key: 'item-edit',
        className: 'header3-item'
      }, {
        label: loggedIn ? 'Logout' : 'Login',
        className: 'header3-item ant-btn ant-btn-primary',
        style: {
          margin: 15,
          paddingTop: 4
        },
        onClick: function onClick() {
          return loggedIn ? Logout() : Login();
        }
      }]
    },
    mobileMenu: {
      id: 'mobile-ham',
      className: 'header3-mobile-menu'
    }
  };
};

var NavHam = function NavHam(_ref4) {
  var phoneClick = _ref4.phoneClick,
      isMobile = _ref4.isMobile;
  if (!isMobile) return null;
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line */
    (0,jsx_runtime.jsx)("div", {
      className: "header3-mobile-menu",
      onClick: phoneClick,
      style: {
        "float": 'right'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuOutlined/* default */.Z, {
        size: "large"
      })
    })
  );
};

var Header3 = function Header3(_ref5) {
  var isMobile = _ref5.isMobile,
      allBrokers = _ref5.allBrokers,
      navCalculators = _ref5.navCalculators,
      props = (0,objectWithoutProperties/* default */.Z)(_ref5, nav3_excluded);

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(authStatus/* default */.Z),
      logged = _useContext.logged;

  var routerSlug = router.query.slug;

  var _useState = (0,react.useState)(undefined),
      phoneOpen = _useState[0],
      setPhoneOpen = _useState[1];

  var _useState2 = (0,react.useState)(logged),
      loggedIn = _useState2[0],
      setLoggedIn = _useState2[1];

  (0,react.useEffect)(function () {
    var _localStorage;

    if ((_localStorage = localStorage) !== null && _localStorage !== void 0 && _localStorage.getItem('authToken')) {
      setLoggedIn(true);
    }
  }, []);

  var phoneClick = function phoneClick() {
    setPhoneOpen(!phoneOpen);
  };

  var dataSourceWithBrokers = dataSource({
    loggedIn: loggedIn,
    allBrokers: allBrokers,
    navCalculators: navCalculators
  });
  var navData = dataSourceWithBrokers.Menu.dataArray;
  var moment = phoneOpen === undefined ? 300 : null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(rc_tween_one_es/* default */.ZP, nav3_objectSpread(nav3_objectSpread(nav3_objectSpread({
    component: "header",
    animation: {
      opacity: 0,
      type: 'from'
    }
  }, dataSourceWithBrokers.wrapper), props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", nav3_objectSpread(nav3_objectSpread({}, dataSourceWithBrokers.page), {}, {
      className: "".concat(dataSourceWithBrokers.page.className).concat(phoneOpen ? ' open' : ''),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(rc_tween_one_es/* default */.ZP, nav3_objectSpread(nav3_objectSpread({
        animation: {
          x: -30,
          type: 'from',
          ease: 'easeOutQuad'
        }
      }, dataSourceWithBrokers.logo), {}, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            width: "100%",
            src: dataSourceWithBrokers.logo.children,
            alt: "img"
          })
        })
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(NavHam, {
        phoneClick: phoneClick,
        isMobile: isMobile
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(rc_tween_one_es/* default */.ZP, nav3_objectSpread(nav3_objectSpread({}, dataSourceWithBrokers.Menu), {}, {
        animation: isMobile ? {
          x: 0,
          height: 0,
          duration: 300,
          onComplete: function onComplete(e) {
            if (phoneOpen) {
              e.target.style.height = 'auto';
            }
          },
          ease: 'easeInOutQuad'
        } : null,
        moment: moment,
        reverse: !!phoneOpen,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* default */.Z, {
          mode: isMobile ? 'inline' : 'horizontal',
          defaultSelectedKeys: routerSlug ? ["sub-".concat(routerSlug)] : [],
          theme: "light",
          items: navData
        })
      }))]
    }))
  }));
};

/* harmony default export */ var nav3 = (Header3);
;// CONCATENATED MODULE: ./layouts/application.tsx



var _templateObject, _templateObject2, _templateObject3, _templateObject4;

/* global google */


















var logPageView = function logPageView() {
  dist/* default.send */.ZP.send({
    hitType: 'pageview',
    page: window.location.pathname
  });
};

var initGA = function initGA() {
  dist/* default.initialize */.ZP.initialize('G-TVCPZRB2XE');
};

var NotificationMessage = function NotificationMessage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hide-mobile",
      style: {
        marginBottom: '8px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RightSideBanner, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ZerodhaAccount/* default */.Z, {
      type: "primary",
      children: "Open Free Zerodha Account"
    })]
  });
};

var oneTapLogin = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation oneTapLogin($token: String, $country: String) {\n    oneTapLogin(token: $token, country: $country)\n  }\n"])));
function ApplicationLayout(props) {
  var _useState = (0,react.useState)(false),
      isMobile = _useState[0],
      setMobile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showNotification = _useState2[0],
      setShowNotification = _useState2[1];

  var country = props.country;
  var router = (0,next_router.useRouter)();

  var _useMutation = (0,useMutation/* useMutation */.D)(oneTapLogin),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      oneTap = _useMutation2[0];

  var openNotification = function openNotification(placement) {
    notification/* default.open */.Z.open({
      message: "Free Share Investment Account with Zerodha",
      description: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationMessage, {}),
      placement: placement,
      duration: 0,
      style: {
        zIndex: 100
      }
    });
  };

  var handleLogin = function handleLogin(data) {
    if (data) {
      localStorage.setItem('authToken', data.jwt);
      localStorage.setItem('userEmail', data.user.email);
      localStorage.setItem('userId', data.user.id);
      (0,redux_flash_messages_lib.addSuccess)({
        text: 'Sign In Successfull'
      });
      router_default().reload();
    }
  }; // eslint-disable-next-line


  (0,react.useEffect)(function () {
    (0,main/* enquireScreen */.ac)(function (b) {
      setMobile(!!b);
    });
    router.events.on('routeChangeStart', function () {
      notification/* default.destroy */.Z.destroy();
    });
    var timer1 = setTimeout(function () {
      return setShowNotification(true);
    }, 8000);

    if (true) {
      window.Globals = window.Globals || {};

      if (!window.Globals.GA_INITIALIZED) {
        window.Globals.GA_INITIALIZED = true;
        initGA();
      }

      logPageView();
      router.events.on('routeChangeComplete', function () {
        // call previously defined callback if is a function
        // log page
        logPageView();
      }); // this will clear Timeout when component unmount like in willComponentUnmount

      return function () {
        clearTimeout(timer1);
      };
    }
  }, [router]);
  (0,react.useEffect)(function () {
    if (showNotification) {
      if (country) {
        var _country$attributes;

        if ((country === null || country === void 0 ? void 0 : (_country$attributes = country.attributes) === null || _country$attributes === void 0 ? void 0 : _country$attributes.name) === 'India') {
          openNotification('bottomRight');
        }
      } else {
        openNotification('bottomRight');
      }
    }
  }, [showNotification, country]);

  var _useState3 = (0,react.useState)(false),
      logged = _useState3[0],
      setLogged = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      jwt = _useState4[0],
      setJwt = _useState4[1];

  var setLogin = function setLogin(status) {
    setLogged(status);
  };

  var setToken = function setToken(token) {
    setJwt(token);
  };

  var ContextPage = (0,react.useMemo)(function () {
    return {
      logged: logged,
      setLogin: setLogin
    };
  }, [logged]);
  var jwtContext = (0,react.useMemo)(function () {
    return {
      jwt: jwt,
      setToken: setToken
    };
  }, [jwt]);
  (0,react.useEffect)(function () {
    try {
      var _localStorage;

      if (!((_localStorage = localStorage) !== null && _localStorage !== void 0 && _localStorage.authToken)) {
        var _script = document.createElement('script');

        _script.src = 'https://accounts.google.com/gsi/client';
        _script.async = true;
        _script.defer = true;

        _script.onload = function () {
          google.accounts.id.initialize({
            client_id: '130680529231-9pppc6vu82aqgspv43nui4o8u9v96f6d.apps.googleusercontent.com',
            callback: function callback(response) {
              if (response.credential) {
                oneTap({
                  variables: {
                    token: response.credential,
                    country: (0,nookies_dist.parseCookies)().country
                  }
                }).then(function (resp) {
                  if (resp.data && resp.data.oneTapLogin && resp.data.oneTapLogin.jwt && resp.data.oneTapLogin.user.email) {
                    handleLogin(resp.data.oneTapLogin);
                  } else {
                    es_message/* default.error */.ZP.error('Sorry Something Went Wrong!');
                  }
                })["catch"](function (err) {
                  return es_message/* default.error */.ZP.error(err);
                });
              }
            }
          });
          google.accounts.id.prompt(); // Add CSS to the document

          var style = document.createElement('style');
          style.innerHTML = '.qJTHM { z-index: 9999; }';
          document.head.appendChild(style);
        };

        _script.onerror = function (err) {
          console.error('Failed to load GSI script:', err);
        };

        document.body.appendChild(_script);
      } // Convertbox


      var script = document.createElement('script');
      script.src = 'https://cdn.convertbox.com/convertbox/js/embed.js';
      script.async = true;
      script.defer = true;
      script.id = 'app-convertbox-script';
      script.dataset.uuid = 'c0a9f9a7-1d06-4e67-9984-ba23e4cb185f';

      script.onerror = function (err) {
        console.error('Failed to load CB script:', err);
      };

      document.body.appendChild(script);
    } catch (err) {
      es_message/* default.error */.ZP.error('Please enable cookies to visit this website');
    }
  }, []);
  var children = props.children,
      allBrokers = props.allBrokers,
      navCalculators = props.navCalculators,
      allPages = props.allPages;
  var childrenWithProps = react.Children.map(children, function (child) {
    // Checking isValidElement is the safe way.
    if ( /*#__PURE__*/(0,react.isValidElement)(child)) {
      var elemProps = {
        isMobile: isMobile
      };
      return /*#__PURE__*/(0,react.cloneElement)(child, elemProps);
    }

    return child;
  });

  var listObjectsWithCount = function listObjectsWithCount(objects, count) {
    return objects.slice(0, objects.length > count ? count : objects.length);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(authStatus/* default.Provider */.Z.Provider, {
    value: ContextPage,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(authToken/* default.Provider */.Z.Provider, {
      value: jwtContext,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav3, {
          isMobile: isMobile,
          allBrokers: listObjectsWithCount(allBrokers, 6),
          navCalculators: listObjectsWithCount(navCalculators, 5)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(flash_messages, {}), childrenWithProps, /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_Footer, {
          id: "Footer1_0",
          isMobile: isMobile,
          allPages: allPages,
          country: country
        }, "Footer1_0")]
      })
    })
  });
}
ApplicationLayout.fragments = {
  all_brokers: (0,lib/* gql */.Ps)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    fragment AllBrokers on Broker {\n      name\n      slug\n      details\n    }\n  "]))),
  nav_calculators: (0,lib/* gql */.Ps)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    fragment NavCalculators on Calculator {\n      name\n      slug\n    }\n  "]))),
  all_pages: (0,lib/* gql */.Ps)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    fragment AllPages on Page {\n      title\n      slug\n    }\n  "])))
};

/***/ })

}]);